import { UliActivityType, UliOrigin } from '../../../../../../../common/constants';
import { ControlProperty } from '../../../../../../../common/models';
import { AllocationViewLeadUliModel, isLeadUli } from '../../allocation-view-lead-uli/allocation-view-lead-uli.model';
import { AllocationViewUliSlotModel } from '../uli-slot/uli-slot.model';
import { FormControl } from '@angular/forms';

export class AllocationViewUliInfoItemModel {
  complete = false;
  loadNumber: string = null;
  type: UliActivityType = null;
  uli: string = null;
  hasDangerousGoods = false;
  origin: UliOrigin;
  compartmentId: number;
  hasCustomsGoods: false;
  selected: boolean;
  ruleId: number;
  allocationSlot: AllocationViewUliSlotModel;
  documentNumbers: string[];

  constructor(params?: AllocationViewUliInfoItemFormModel) {
    if (params) {
      const { leadUli: _leadUli, ...rest } = params;
      Object.assign(this, rest);
    }
  }
}

export class AllocationViewUliInfoItemFormModel extends AllocationViewUliInfoItemModel {
  leadUli: boolean;

  constructor(params?: AllocationViewUliInfoItemModel, leadUlis?: AllocationViewLeadUliModel[]) {
    super();
    if (params) {
      Object.assign(this, params);

      this.leadUli = isLeadUli(
        leadUlis,
        params.uli,
        params.type,
        params.allocationSlot?.compartmentId ?? params.compartmentId,
      );
      this.selected = params.selected || this.leadUli;
    }
  }
}

export class AllocationViewUliInfoItemForm {
  constructor(
    model: AllocationViewUliInfoItemModel,
    public complete: ControlProperty<boolean> = model.complete,
    public loadNumber: ControlProperty<string> = model.loadNumber,
    public type: ControlProperty<UliActivityType> = model.type,
    public uli: ControlProperty<string> = model.uli,
    public hasDangerousGoods: ControlProperty<boolean> = model.hasDangerousGoods,
  ) {}
}

export class AllocationViewRegisterUliInfoForm {
  constructor(
    model: AllocationViewUliInfoItemFormModel,
    public complete: FormControl<boolean> = new FormControl(model.complete),
    public loadNumber: FormControl<string> = new FormControl(model.loadNumber),
    public type: FormControl<UliActivityType> = new FormControl(model.type),
    public uli: FormControl<string> = new FormControl(model.uli),
    public hasDangerousGoods: FormControl<boolean> = new FormControl(model.hasDangerousGoods),
    public origin: FormControl<UliOrigin> = new FormControl(model.origin),
    public compartmentId: FormControl<number> = new FormControl(model.compartmentId),
    public hasCustomsGoods: FormControl<boolean> = new FormControl(model.hasCustomsGoods),
    public selected: FormControl<boolean> = new FormControl(model.selected),
    public ruleId: FormControl<number> = new FormControl(model.ruleId),
    public allocationSlot: FormControl<AllocationViewUliSlotModel> = new FormControl(model.allocationSlot),
    public documentNumbers: FormControl<string[]> = new FormControl(model.documentNumbers),
    public leadUli: FormControl<boolean> = new FormControl(model.leadUli),
  ) {}
}
